/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adr_SetupInputs */

const en_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR Setup`)
};

const fr_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration ADR`)
};

const de_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR-Einrichtung`)
};

const it_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione ADR`)
};

const ru_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка ADR`)
};

const es_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de ADR`)
};

const zh_cn2_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR设置`)
};

const ja_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADRの設定`)
};

const hi_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडीआर सेटअप`)
};

const pt_pt2_adr_setup = /** @type {(inputs: Adr_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração de ADR`)
};

/**
* | output |
* | --- |
* | "ADR Setup" |
*
* @param {Adr_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const adr_setup = /** @type {((inputs?: Adr_SetupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adr_SetupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_adr_setup(inputs)
	if (locale === "de") return de_adr_setup(inputs)
	if (locale === "it") return it_adr_setup(inputs)
	if (locale === "ru") return ru_adr_setup(inputs)
	if (locale === "es") return es_adr_setup(inputs)
	if (locale === "zh-CN") return zh_cn2_adr_setup(inputs)
	if (locale === "ja") return ja_adr_setup(inputs)
	if (locale === "hi") return hi_adr_setup(inputs)
	if (locale === "pt-PT") return pt_pt2_adr_setup(inputs)
	return en_adr_setup(inputs)
});